import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { UserPlus } from 'lucide-react';
import type { DashboardStats, TranslateFn } from '../../types';

interface DashboardTabProps {
  stats: DashboardStats | null;
  t: TranslateFn;
  setActiveTab: (tab: string) => void;
  setShowAddTherapist: (show: boolean) => void;
}

export const DashboardTab = ({ stats, t, setActiveTab, setShowAddTherapist }: DashboardTabProps) => (
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">{t('admin.totalBookings')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold">{stats?.bookings?.total || 0}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">{t('common.pending')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-yellow-600">{stats?.bookings?.pending || 0}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">{t('admin.inProgress')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-blue-600">
            {(stats?.bookings?.assigned || 0) + (stats?.bookings?.accepted || 0)}
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">{t('common.completed')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-green-600">{stats?.bookings?.completed || 0}</div>
        </CardContent>
      </Card>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">{t('admin.therapistAvailability')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between">
            <span className="text-gray-600">{t('common.available')}</span>
            <span className="text-2xl font-bold text-green-600">
              {stats?.therapists?.available || 0} / {stats?.therapists?.total || 0}
            </span>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">{t('admin.quickActions')}</CardTitle>
        </CardHeader>
        <CardContent className="flex gap-2 flex-wrap">
          <Button onClick={() => setActiveTab('bookings')} variant="outline" size="sm">
            {t('admin.viewBookings')}
          </Button>
          <Button onClick={() => setActiveTab('calendar')} variant="outline" size="sm">
            {t('admin.calendarView')}
          </Button>
          <Button onClick={() => setShowAddTherapist(true)} size="sm">
            <UserPlus className="w-4 h-4 mr-2" />
            {t('admin.addTherapist')}
          </Button>
        </CardContent>
      </Card>
    </div>
  </>
);
